
/*
 * Module Comment
*/

rs.module("development/codedemosfile-upload",

    [],

    function () {

        // Initialize the page module.
        function initialize(fileUploadA, fileUploadB, jsSelectors) {

            // Click handler for the first upload control's clear button.
            $.js(jsSelectors.clearControlA).on('click', function() {
                fileUploadA.clear();
            });


            // Click handler for the second upload control's clear button.
            $.js(jsSelectors.clearControlB).on('click', function() {
                fileUploadB.clear();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);